import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from './balloon.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { BALLOON_POSITIONS, BALLOON_ALIGNMENTS, BALLOON_SIZES } from './types.js';
import Button from '../button/button.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bemBalloon = HoneyBem.init('balloon', styles);
var Balloon = function (_a) {
  var innerRef = _a.innerRef,
    children = _a.children,
    closeProps = _a.closeProps,
    extraClasses = _a.extraClasses,
    customBem = _a.customBem,
    _b = _a.position,
    position = _b === void 0 ? 'right' : _b,
    alignment = _a.alignment,
    _c = _a.danger,
    danger = _c === void 0 ? false : _c,
    size = _a.size,
    rest = __rest(_a, ["innerRef", "children", "closeProps", "extraClasses", "customBem", "position", "alignment", "danger", "size"]);
  var bemObj = customBem || bemBalloon;
  var balloonClassNames = bemObj.b([{
    active: !rest.hidden,
    danger: danger,
    top: position === 'top',
    left: position === 'left',
    bottom: position === 'bottom',
    start: alignment === 'start',
    end: alignment === 'end'
  }, size], extraClasses);
  return /*#__PURE__*/React__default__default.createElement("div", __assign({
    ref: innerRef,
    className: balloonClassNames
  }, rest), /*#__PURE__*/React__default__default.createElement("div", {
    className: bemObj.e('content')
  }, children), closeProps && /*#__PURE__*/React__default__default.createElement(Button, __assign({
    link: true,
    display: "square",
    size: "sm",
    extraClasses: bemObj.e('close', false, closeProps.className)
  }, closeProps)));
};
Balloon.displayName = 'Balloon';
Balloon.propTypes = {
  // @todo figure out how to make TypeScript agreed with this:
  // PropTypes.shape({
  //  current: PropTypes.instanceOf(typeof HTMLDivElement === 'undefined'
  //   ? () => null
  //   : HTMLDivElement)
  // }),
  innerRef: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.shape({
    current: PropTypes__default.object
  })]),
  children: PropTypes__default.node.isRequired,
  closeProps: PropTypes__default.shape({
    onClick: PropTypes__default.func.isRequired,
    'aria-label': PropTypes__default.string.isRequired,
    className: PropTypes__default.string
  }),
  danger: PropTypes__default.bool,
  extraClasses: PropTypes__default.string,
  customBem: PropTypes__default.object,
  position: PropTypes__default.oneOf(BALLOON_POSITIONS),
  alignment: PropTypes__default.oneOf(BALLOON_ALIGNMENTS),
  size: PropTypes__default.oneOf(BALLOON_SIZES)
};
var Balloon$1 = Injecss(Balloon, styles);

export { Balloon, Balloon$1 as default };
